/* main style */
import "../styles/main.scss";

/* helpers */
import R2Dom from "./helpers/R2Dom";
import "./helpers/globals";

/* import global methods and init R2Dom */
function importAll (r) {
    r.keys().forEach(r);
}
importAll(require.context("./methods-global/", true, /\.js$/));

/* init */
R2Dom.Init();
console.warn("src/index.js Successfuly Loaded !");
console.warn("<<----- This is last script to load, you should delete console warns above ----->>");